// All over the file changes has been done by Dev srini on 07/08/24

import { useEffect, useState, useCallback, useContext } from 'react'

import { withStyles } from '@material-ui/core/styles'
import { Typography } from '@material-ui/core'

import { parse, isToday, isYesterday } from 'date-fns'
import dayjs from 'dayjs'
import axios from 'axios'
import DateFields from './SearchFields/DateFields'
import EmailNameMobileFields from './SearchFields/EmailNameMobileFields'
import FilterFields from './SearchFields/FilterFields' //dev-trupti on 26-12-2024
import TableDisplay from './TableContent/TableDisplay'
import EditActionModal from './TableContent/EditActionModal'

import { httpRequest } from '../../../../ui-utils/api'
import { backendHosts, apiUrl } from '../../../../ui-utils/apiConfig'
import styles from '../InCompleteKYC/InCompleteKYCStyles'

import {SnackbarContent,Snackbar, IconButton, Grid,Tabs,Tab } from "@mui/material";
import CloseIcon from '@mui/icons-material/Close';
// importing exportJson - srini - 21/11/24
import exportFromJSON from 'export-from-json'
import { Password } from '@mui/icons-material'
import Lead from './Lead'
import FilterButtons from './FilterButtons'
import { reducerContext } from '../../../../contextApi\'s/contextApi\'s'
import snackError from '../../../../helpers/snackError'
const InCompleteKYC = ({ classes }) => {

    const { state, dispatch } = useContext(reducerContext)

    const [accountno, setAccountNo] = useState("")
    const [editModal, setEditModal] = useState(false)
    const [fatherName, setFatherName] = useState("")
    const [inCompleteKyc, setIncompleteKyc] = useState([])
    const [kycEmail, setKycEmail] = useState("")
    const [kycFdate, setKycFDate] = useState(null)
    const [kycMobile, setKycMobile] = useState("")
    const [kycAadhar, setKycAadhar] = useState("")
    const [kycrefCode, setkycRefCode] = useState("") //Added Refcode dev-trupti 22-10-2024
    const [kycName, setKycName] = useState("")
    const [kycTdate, setKycTDate] = useState(null)
    const [prefix, setPrefix] = useState("")
    const [selectUser, setSelectedUser] = useState({})
    const [completeKyc, setcompleteKyc] = useState([])
    const [checkboxToggle, setcheckboxToggle] = useState("in_progress")
    const [regData, setRegData] = useState([])
    const [aadhar, setAadhar] = useState("")
    const [phone, setPhone] = useState("")
    const [email, setEmail] = useState("")
    const [accountnumber, setAccountnumber] = useState("")
    const [load, setLoad] = useState(false)
    const [bankAccount, setBankAccount] = useState(null)
    const [image, setImage] = useState("")
    const [snack, setSnack] = useState(false)
    const [msg, setMsg] = useState("")
    const [disRepush, setDisRepush] = useState(false)
    const [reset, setReset] = useState(false) //dev-trupti on 24-10-2024
    const [subData, setSubData] = useState({}) //dev-trupti on 31-10-2024
    const [status, setStatus] = useState(false) //dev-trupti on 26-11-2024
    const [hide, setHide] = useState(true)
    const [filterModel, setFilterModel] = useState({ items: [] });
    const [kycClient, setKycClient] = useState("") //dev-trupti on 26-12-2024
    const [nri, setNri] = useState({ //dev-trupti on 31-12-2024
        pis_filename:'',
        pan_filename:'',
        identity_filename:'',
        bankstatment_filename:'',
        communicationadd_filename:''
    })
    const [selectPlan, setSelectPlan] = useState('') // kartik - 10-01-2025
    const [count, setCount] = useState(null) // kartik - 16-01-2025
    const [docstatus, setDocstatus] = useState([])
    const [docobj, setDocobj] = useState({})


    const [picDetails,setPicDetails]=useState(null)

    const [kycDetails, setKycDetails] = useState(null)
    const [bankData, setBankData] = useState(null)
    const [details,setDetails]=useState(null)
    const [personalDetails, setPersonalDetails] = useState(null)
    const [segmentDetails, setSegmentDetails] = useState(null)
    const [nomineeDetails, setNomineeDetails] = useState(null)
   


 




    const [perData,setPerData]=useState(null)
    const [num,setNum]=useState(0)
    const [id,setId]=useState(null)

    const [docVerification, setDocVerification] = useState(null)
    const [tabId, setTabId] = useState(1);
    const [allKycData, setAllKycData] = useState([]);
    const [selectedStatus, setSelectedStatus] = useState("");

    const sortGetData = (incompleteData) => {

        const result = incompleteData.sort((a, b) => {
            // Convert string to Date object
            const dateA = new Date(a.created_on);
            const dateB = new Date(b.created_on);
            
            // Sort in descending order
            return dateB - dateA;
          })

        return result
    }

    //dev-trupti on 24-10-2024
    const handleReset = () =>{
        setReset(!reset)
        setStatus(false) //dev-trupti on 26-11-2024
        setHide(true)
        setcheckboxToggle("in_progress")
        setKycName("") //dev-trupti on 17-12-2024
        setKycEmail("")
        setKycMobile("")
        setKycAadhar("")
        setSelectPlan("")
        setkycRefCode("") 
        setKycFDate(null)
        setKycTDate(null)
        setKycClient("") //dev-trupti on 26-12-2024
        setSelectPlan("")  //kartik - 10-01-2025
        setCount(null)  //kartik - 16-01-2025
        setDocstatus([])
        setSelectedStatus("")
    }

    //kartik - 16-01-2025
    // useEffect(() => {
    //     console.log(count)
    // }, [count])

    useEffect(() => {
        (async () => {
            //dev-trupti on 17-12-2024
            // const franchisee_list = JSON.parse(localStorage.getItem("sipRegData")).franchaise_list || []

            // const rtype = franchisee_list.length > 0 ? "Franchisee" : "All"
            let payload ={data:{  "from": "", "to": "",  "name": "", "email": "", "mobile": "", "aadhaar": "", "client_id": "","referral_code":"" }}
            try {
                // srini - 11/11/24
                const result = await axios.post(`${backendHosts.ADMIN}${apiUrl.allUsersAndFilter}`,payload ,{
                    headers : {
                        "Authorization" : localStorage.getItem('token')
                    }
                })

                const incompleteData = result?.data?.data?.data?.data.filter(item => item.kyc_status == 'in_progress')
                setKycDetails(result?.data?.data?.data?.data)
                setAllKycData(result?.data?.data?.data?.data)
                setSelectedStatus("in_progress")
                setIncompleteKyc(incompleteData)
                setcompleteKyc(result?.data?.data?.data?.data)
                

                if(result?.data?.data?.status !== 200){ // added by Ayush - 08-09-2026
                    dispatch({ type: 'SET_SHOW_ERROR', payload: true })
                    dispatch({ type: 'SET_ERROR', payload: "something went wrong" })
                    dispatch({ type: 'SET_MY_SNACK', payload: snackError.myError })
                }
         

                // // srini - 11/11/24
                // console.log("status", result.data.data.status)
                // console.log("data", result.data.data.data.data)
                // if (result.data.data.status === 200) {
                //     setcompleteKyc(result.data.data.data.data)
                //     // Filter out completed entries
                //     // srini - 11/11/24
                //     // const incompleteData = result.data.filter(item => item.stage !== 'completed' && item.status=='ACTIVE') //dev-trupti on 26-11-2024

                //     // Sort the remaining entries by the latest date
                //     // let sortResult = sortGetData(incompleteData)

                //     setIncompleteKyc(result.data.data.data.data)
                //     // console.log("Sorted final data", sortResult)
                // }
                // else{
                //     // srini - 11/11/24
                //     console.log('Error in Admin Report API', result)
                // }
            }
            catch (error) {
                // srini - 11/11/24
                // added by Ayush - 08-09-2026
                dispatch({ type: 'SET_SHOW_ERROR', payload: true })
                dispatch({ type: 'SET_ERROR', payload: error?.response?.data?.data?.message || "something went wrong" })
                dispatch({ type: 'SET_MY_SNACK', payload: snackError.myError })
                console.log('Error in Admin Report API', error)
            }
        })()
    }, [reset]) //dev-trupti on 24-10-2024
    // setKycDetails(inCompleteKyc)
    // console.log("useEff", kycDetails)

    // Clears all filters
    const handleClearFilters = () => {
        setFilterModel({ items: [] });
        setcheckboxToggle("")  //dev-trupti on 24-10-2024
    };

    const handleInCompleteKycSubmit = useCallback(async (e) => {
        e.preventDefault()
        handleClearFilters()
            //dev-trupti on 17-12-2024
            // const franchisee_list = JSON.parse(localStorage.getItem("sipRegData")).franchaise_list || []
            // const rtype = franchisee_list.length > 0 ? "Franchisee" : "All"

        let payload = {

            data:{
            from: kycFdate || "",
            to: kycTdate || "" ,
            // "rtype": rtype,
            name: kycName || '',
            email: kycEmail || "",
            mobile: kycMobile || "",
            aadhaar: kycAadhar || "",
            referral_code:kycrefCode || "",
            client_id: kycClient || "",
        }
    }

        console.log("filterPayload",payload)

        //kartik - 10-01-2025        
        // if (selectPlan && kycTdate == null && kycFdate == null) {
        //     try {

        //         const result = await httpRequest({
        //             endPoint: `${backendHosts.ADMIN}${apiUrl.adminReport}`,
        //             method: "post",
        //             instance: "instanceOne",
        //             requestBody: payload
        //         })

        //         if (result.status === 200) {
                    
        //             setcompleteKyc(result.data)
        //             const res = result.data.filter(item => item.stage === 'completed')
        //             setCount(res.length)
        //             // Sort the remaining entries by the latest date
        //             let sortResult = sortGetData(res)
        //             setIncompleteKyc(sortResult)
        //             console.log("Sorted final data", sortResult)
        //         }
        //         else {

        //             console.log('Error in Admin Report API', result)
        //         }
        //     }
        //     catch (err) {
        //         console.log('Error in Admin Report API', err)
        //     }
        // }
        // else if (selectPlan && kycTdate !== null && kycFdate !== null && rtype == "All") {
        //     try {

        //         const result = await httpRequest({
        //             endPoint: `${backendHosts.ADMIN}${apiUrl.adminReport}`,
        //             method: "post",
        //             instance: "instanceOne",
        //             requestBody: payload
        //         })

        //         if (result.status === 200) {

        //             setcompleteKyc(result.data)
        //             const res = result.data.filter(item => item.stage === 'completed')
        //             setCount(res.length)
        //             // Sort the remaining entries by the latest date
        //             let sortResult = sortGetData(res)

        //             setIncompleteKyc(sortResult)
        //             console.log("Sorted final data", sortResult)
        //         }
        //         else {

        //             console.log('Error in Admin Report API', result)
        //         }
        //     }
        //     catch (err) {
        //         console.log('Error in Admin Report API', err)
        //     }
        // }
        // else if (selectPlan && kycTdate == null && kycFdate == null && rtype == "Franchisee") {
        //     try {

        //         const result = await httpRequest({
        //             endPoint: `${backendHosts.ADMIN}${apiUrl.adminReport}`,
        //             method: "post",
        //             instance: "instanceOne",
        //             requestBody: payload
        //         })

        //         if (result.status === 200) {

        //             setcompleteKyc(result.data)
        //             const res = result.data.filter(item => item.stage === 'completed')
        //             setCount(res.length)
        //             // Sort the remaining entries by the latest date
        //             let sortResult = sortGetData(res)

        //             setIncompleteKyc(sortResult)
        //             console.log("Sorted final data", sortResult)
        //         }
        //         else {

        //             console.log('Error in Admin Report API', result)
        //         }
        //     }
        //     catch (err) {
        //         console.log('Error in Admin Report API', err)
        //     }
        // }

        // else if (selectPlan && kycTdate !== null && kycFdate !== null && rtype == "Franchisee") {
        //     try {

        //         const result = await httpRequest({
        //             endPoint: `${backendHosts.ADMIN}${apiUrl.adminReport}`,
        //             method: "post",
        //             instance: "instanceOne",
        //             requestBody: payload
        //         })

        //         if (result.status === 200) {

        //             setcompleteKyc(result.data)
        //             const res = result.data.filter(item => item.stage === 'completed')
        //             setCount(res.length)
        //             // Sort the remaining entries by the latest date
        //             let sortResult = sortGetData(res)

        //             setIncompleteKyc(sortResult)
        //             console.log("Sorted final data", sortResult)
        //         }
        //         else {

        //             console.log('Error in Admin Report API', result)
        //         }
        //     }
        //     catch (err) {
        //         console.log('Error in Admin Report API', err)
        //     }
        // }

        if (kycFdate || kycTdate || kycName || kycEmail || kycMobile || kycAadhar || kycClient || kycrefCode){

        
        
            try {

                const IncompleteKyc = await axios.post(`${backendHosts.ADMIN}${apiUrl.allUsersAndFilter}`,payload,{
                    headers : {
                        Authorization : localStorage.getItem('token')
                    }
                })
                console.log("incompleteKyc", IncompleteKyc.data.data.data)

                if (IncompleteKyc.data.data.data.success === true) {
                    setCount(null)
                    setSelectedStatus("")
                    console.log("inside  incompleteKyc", IncompleteKyc.data.data.data.data)
                    setcompleteKyc(IncompleteKyc.data.data.data.data)
                    setAllKycData(IncompleteKyc?.data?.data?.data?.data)
                    // let incompleteData = IncompleteKyc.data
                    setIncompleteKyc(IncompleteKyc.data.data.data.data)

                    
                        // incompleteData = IncompleteKyc.data.data.data.data.filter(item => item.stage !== 'completed')
                    


                    // Sort the remaining entries by the latest date
                    // let sortResult = sortGetData(incompleteData)
                    // console.log(sortResult, "Sorted final data in the call")//dev-trupti 22-10-2024
                  

                    // setKycName("")//dev-trupti 22-10-2024 to not erase the filter on search
                    // setKycEmail("")
                    // setKycMobile("")
                    // setKycAadhar("")
                    // setkycRefCode("")
                }
                else {
                    // srini - 11/11/24
                    console.log('Error in Admin Report API', IncompleteKyc)
                    // added by Ayush - 08-09-2026
                    dispatch({ type: 'SET_SHOW_ERROR', payload: true })
                    dispatch({ type: 'SET_ERROR', payload: "something went wrong" })
                    dispatch({ type: 'SET_MY_SNACK', payload: snackError.myError })
                }
            }
            catch (error) {
                // srini - 11/11/24
                console.log('Error in Admin Report API', error)
                // Ayush - 08-09-2026
                dispatch({ type: 'SET_SHOW_ERROR', payload: true })
                dispatch({ type: 'SET_ERROR', payload: error?.response?.data?.data?.message || "something went wrong" })
                dispatch({ type: 'SET_MY_SNACK', payload: snackError.myError })
            }
        }
        
    }, [kycFdate, kycTdate, kycName, kycEmail, kycMobile, kycAadhar, kycrefCode, kycClient, selectPlan])//dev-trupti on 26-12-2024 // added selectPlan kartik - 10-01-2025

    
    const handleEditDetails = useCallback(async (user_id) => {
     
      setId(user_id)
      
        try {
            // console.log("id", user_id)
            const userData = await axios.get(`${backendHosts.ADMIN}${apiUrl.allUsersAndFilter}/${user_id}`)
           
            console.log("kyc", kycDetails)
            let incompleteData = kycDetails.filter(item =>
                { 
                    return item.user_id == user_id
        })
            console.log("filterData",incompleteData)
            
            setPerData(incompleteData[0])
            

         console.log("data",userData.data.data.data)
           
         
            let data = userData.data.data.data
            if (userData.data.data.status === 200) {

                let res = []

                if (incompleteData?.[0]?.steps["Aadhaar Verify"]){
                    data.aadhaar.type = "AadhaarDetails"
                    data.aadhaar.status = incompleteData?.[0]?.steps["Aadhaar Verify"]?.status
                    data.aadhaar.aadhaarNo = incompleteData?.[0]?.aadhaar_no 
                    res.push(data.aadhaar)
                }
                        

                if (incompleteData?.[0]?.steps["Pan Verify"]) {
                    data.pan.type = "PanDetails"
                    data.pan.status = incompleteData?.[0]?.steps["Pan Verify"]?.status
                    data.pan.panNo = incompleteData?.[0]?.pan_no
                    res.push(data.pan);
                    data.pan.date = incompleteData?.[0]?.steps["Pan Verify"]?.
                        timestamp
                }
               

                if (incompleteData?.[0]?.steps["Link Bank Account"]) {
                    data.bankDetails.type = "BankDetails"
                    data.bankDetails.status = incompleteData?.[0]?.steps["Link Bank Account"]?.status
                    res.push(data.bankDetails)
                    data.bankDetails.date = incompleteData?.[0]?.steps["Link Bank Account"]?.
                        timestamp
                }
             

                if (incompleteData?.[0]?.steps["Activate F&O"]) {
                    data.segmentDetails.type = "SegmentDetails"
                    data.segmentDetails.status = incompleteData?.[0]?.steps["Activate F&O"]?.status
                    res.push(data.segmentDetails);
                    data.segmentDetails.date = incompleteData?.[0]?.steps["Activate F&O"]?.
                        timestamp

                }
              

                if (incompleteData?.[0]?.steps["Personal Detail"]) {
                    data.personalDetails.type = "PersonalDetails"
                    data.personalDetails.status = incompleteData?.[0]?.steps["Personal Detail"].status
                    res.push(data.personalDetails);
                    data.personalDetails.date = incompleteData?.[0]?.steps["Personal Detail"]?.
                        timestamp
                    console.log("FatherName", data?.personalDetails?.guardian)
                    setFatherName(data?.personalDetails?.guardian || null)
                }

                if (incompleteData?.[0]?.steps["Add Nominee"]) {
                    data.nomineeDetails.type = "NomineeDetails"
                    data.nomineeDetails.status = incompleteData?.[0]?.steps["Add Nominee"]?.status
                    res.push(data.nomineeDetails);
                    data.nomineeDetails.date = incompleteData?.[0]?.steps["Add Nominee"]?.
                        timestamp
                }
              
                if (incompleteData?.[0]?.steps["Capture Selfie"]){
                    data.selfie.type = "Selfie"
                    data.selfie.status = incompleteData?.[0]?.steps["Capture Selfie"].status
                    res.push(data.selfie);
                    data.selfie.date = incompleteData?.[0]?.steps["Capture Selfie"]?.
                        timestamp
                }


                if (incompleteData?.[0]?.steps["Signature"]) {
                    data.signature.type = "Signature"
                    data.signature.status = incompleteData?.[0]?.steps["Signature"].status
                    res.push(data.signature);
                    data.signature.date = incompleteData?.[0]?.steps["Signature"]?.
                        timestamp
                }   
                
                if (incompleteData?.[0]?.steps["DIS Slip"]) {
                    console.log("DIS Slip")
                    const disSlip = {
                        type: "DIS Slip",
                        status: incompleteData?.[0]?.steps["DIS Slip"].status,
                        date: incompleteData?.[0]?.steps["DIS Slip"]?.timestamp,
                    };
                    res.push(disSlip); 
                }

                if (incompleteData?.[0]?.steps["Esign"]) {
                    console.log("Esign")
                    const Esign = {
                        type: "Esign",
                        status: incompleteData?.[0]?.steps["Esign"].status,
                        date: incompleteData?.[0]?.steps["Esign"]?.timestamp,
                    };
                    res.push(Esign);
                }

                if (incompleteData?.[0]?.steps["Subscription Plan"]) {
                    console.log("Subscription Plan")
                    const Payment = {
                        type: "Payment",
                        status: incompleteData?.[0]?.steps["Subscription Plan"].status,
                        date: incompleteData?.[0]?.steps["Subscription Plan"]?.timestamp,
                    };
                    res.push(Payment);
                }

                if (incompleteData?.[0]?.steps["Congrats Page"]) {
                    console.log("Congrats Page")
                    const Congrats = {
                        type: "Congrats Page",
                        status: incompleteData?.[0]?.steps["Congrats Page"].status,
                        date: incompleteData?.[0]?.steps["Congrats Page"]?.timestamp,
                    };
                    res.push(Congrats);
                }
                // res.push({ id: 4, name: "Object 4" });
                // res.push({ id: 5, name: "Object 5" });
                console.log("details",res)
                setDetails(res)

                // setBankData(data.bankDetails)
                // setNomineeDetails(data.nomineeDetails)
                // setSegmentDetails(data.segmentDetails)
                // setPersonalDetails(data.personalDetails)
                setRegData(data.api_response_data)
                console.log("verify",data.aadhaar.verified)

                let details = {
                    aadhaar: {
                        data: data.aadhaar.data?.content,
                        verify: data.aadhaar.verified,
                    },
                    pan: {
                        data: data.pan.data?.content,
                        verify: data.pan.verified,
                    },
                    selfie: {
                        data: data.selfie.data?.content,
                        verify: data.selfie.verified,
                    },
                    signature: {
                        data: data.signature.data?.content,
                        verify: data.signature.verified,
                    },
                    account_opening_form: {
                        data: data.account_opening_form.data?.content,

                    },
                    cancelled_cheque: {
                        data: data.cancelled_cheque.data?.content,
                        verify: data.cancelled_cheque.verified,
                    },
                    fno_activation:{
                        data: data.fno_activation.data?.content,
                        verify: data.fno_activation?.verified,
                        type: data.fno_activation?.type,
                        password:data.fno_activation?.password
                    }
                }

                setPicDetails(details)


                const verified = Object.keys(details).filter(
                    (key) => details[key]?.verify === false
                )
                console.log("verifydocs", verified)
                setDocVerification(verified)
                
                console.log("perData", incompleteData)
                setEditModal(true)
                // console.log(stage)
                // setSelectedUser({ ...userData.data[0], stage, full_name, citizenship, updated_on, panname, full_aadhar, full_pan, bank_name, bank_ifsc, bank, bankstmtpwd})
                // setFatherName(father_name)
                // setPrefix(accountno_prefix)
                // setAccountNo(accountno)
                // setAccountnumber(accountno)
                // setAadhar(aadhar)
                // setPhone(phone)
                // setEmail(email)
                // setBankAccount(bank)
                // setDocobj(JSON.parse(document_status))
                // //Setting the document status
                // const docstatus =JSON.parse(document_status)
                // const array =[]
                // for (let key in docstatus) {
                //     if (docstatus.hasOwnProperty(key)) {
                //         // array.push(key)
                //         if (docstatus[key] !== 'approved') {
                //             array.push(key)
                //         } 
                //     }
                // }
                // setDocstatus(array)

            }
            else{
                // srini - 11/11/24
                console.log('Error in Kyc Pending API', userData)
            }
        }
        catch (error) {
            // srini - 11/11/24
            console.log('Error in Kyc Pending API', error)
        }
// Worked on modal by dev-trupti on 21-08-2024
        // try{
        //     const secPayload={
        //         email,
        //         phone
        //     }
        //     const reg_data = await httpRequest({
        //         endPoint:`${backendHosts.ADMIN}${apiUrl.registration}`,
        //         method:"post",
        //         instance: "instanceOne",
        //         requestBody:secPayload
        //     })

        //     if(reg_data.status === 200) {
        //         setRegData(reg_data.data)
        //     }
        //     else{
        //         // srini - 11/11/24
        //         console.log('Error in Registration API', reg_data)
        //     }
        // }catch(error){
        //     // srini - 11/11/24
        //     console.log('Error in Registration API', error)
        // }


        // try {// added by dev-kartik on 02-04-25

        //     if (email.length !== 0 && phone.length !== 0) {
        //         const getData = await httpRequest({
        //             endPoint: `${backendHosts.ADMIN}${apiUrl.getUser}`,
        //             method: "post",
        //             instance: "instanceOne",
        //             requestBody: payload,
        //         });
        //         const result = getData.data

        //         if (result.length === 0) {
        //             setUser([]);
        //         } else {
        //             setUser(result);
        //         }
        //     }

        // } catch (error) {
        //     console.error("Error fetching client data:", error);
        // }



        // //Worked on pending bank Check by dev-trupti on 22-8-2024
        // if(bank === null  || stage==='completed_bvpending'){ //Updated bank pending verification dev-trupti 22-10-2024
        //     let filename = phone+"_"+aadhar+"_bankcheque.jpg"
        // let payload = {
        //     filename: filename
        // }
        // const downloadData = await httpRequest({
        //     endPoint: `${backendHosts.ADMIN}${apiUrl.bankCheque}`,
        //     method: "post",
        //     instance: "instanceOne",
        //     requestBody:payload
        // })        
        // if(downloadData.status === 200) {
        //     setImage(downloadData.img)
        // }else if(downloadData.error.statusCode===404 ){
        //     // srini - 11/11/24
        //     console.log('Error in Bank Cheque API', downloadData)
        // }
        // }
        // //Worked on subcription API call by dev-trupti on 28-10-2024
        // try{
        //     const secPayload={
        //         "clientid":accountno_prefix + accountno,
        //         "mobileno" : phone
        //     }
        //     const reg_data = await httpRequest({
        //         endPoint:`${backendHosts.ADMIN}${apiUrl.subscription}`,
        //         method:"post",
        //         instance: "instanceOne",
        //         requestBody:secPayload
        //     })

        //     if(reg_data.status === 200) {
        //         setSubData(reg_data.data)
        //     }
        // }catch(err){
        //     console.log(err)
        // }
        // //Checking if the client is an NRI by dev-trupti on 31-12-2024
        // if(citizenship == 1){
        //     let payload1 = { "emailid": email, "mobile": phone }
        //     const nriData = await httpRequest({
        //         endPoint:`${backendHosts.ADMIN}${apiUrl.nriUploadData}`,
        //         method:"post",
        //         instance: "instanceOne",
        //         requestBody:payload1
        //     })
        //     if(nriData.status === 200){
        //         const pis_filename = nriData.data.find(item=> item.proof_type ==="pis")?.image_name || ""
        //         const pan_filename = nriData.data.find(item=> item.proof_type ==="pancard")?.image_name || ""
        //         const identity_filename = nriData.data.find(item=> item.proof_type ==="Identity")?.image_name || ""
        //         const bankstatment_filename = nriData.data.find(item=> item.proof_type ==="bankstatment")?.image_name || ""
        //         const communicationadd_filename = nriData.data.find(item=> item.proof_type ==="communicationadd")?.image_name || ""
        //         setNri({
        //             pis_filename,
        //             pan_filename,
        //             identity_filename,
        //             bankstatment_filename,
        //             communicationadd_filename
        //         })
        //     }
        // }
    }, [kycDetails])

    const handleRepush =async() => {
        setLoad(true)
        let payload = { 
            accountno_prefix: prefix,
            accountno: accountno === "" ? 0: accountno,
            father_name:fatherName,
            phone:phone,
            email: email
        }
        try{
            const updatedData = await httpRequest({
                endPoint:`${backendHosts.ADMIN}${apiUrl.rePush}`,
                method:"post",
                instance: "instanceOne",
                requestBody:payload
            })
            if(updatedData.status === 200){
                const repushedData = inCompleteKyc.map((ele)=>{
                    if(ele.phone===updatedData.data[0].phone && ele.email===updatedData.data[0].email){
                        return updatedData.data[0]
                    }
                    else{
                        return ele
                    }
                })
                setIncompleteKyc(repushedData)
                setLoad(false)
                setDisRepush(true)
                setSnack(true)
                setMsg("The Data was Repushed successfully")
                //Added Back office api call dev-trupti 22-10-2024
                const kycPayload = {
                    emailid:email,
                    mobileno:phone,
                    type: bankAccount === null? 2 : 0
                }
                const kyc = await httpRequest({
                    endPoint: `${backendHosts.REG}${apiUrl.kyc}`,
                    method: "post", 
                    instance: "instanceOne",
                    requestBody:kycPayload
                })
                if(kyc.status=== 200){
                    setSnack(true)
                    setMsg(`${kyc?.message}`)
                }else{
                    setSnack(true)
                    setMsg("An error occured")
                    // srini - 11/11/24
                    console.log('Error in KYC API', kyc)
                }

            }
            else{
                // srini - 11/11/24
                console.log('Error in Re Push API', updatedData)
            }
        }catch(error){
            // srini - 11/11/24
            console.log('Error in Re Push API', error)
            setSnack(true)
            setMsg("An Error Occured")
            setLoad(false)
        }
    }

    const CompletedVerification = (acc, ifsc, bankHolderName, document_status)=>{
        if(Object.keys(document_status).length !== 0){
            const UpdatedData = inCompleteKyc.map((ele)=>{
                if(ele.email===email){
                    return {...ele, document_status}
                }else{
                    return ele
                }
            })
            setIncompleteKyc(UpdatedData)
        }else{
            const UpdatedData = inCompleteKyc.map((ele)=>{
                if(ele.email===email){
                    return {...ele, bankaccount:acc, ifsc:ifsc, bankname:bankHolderName}
                }else{
                    return ele
                }
            })
            setIncompleteKyc(UpdatedData)
        }
    }

    const handlePlans = useCallback((e) => {     // kartik - 10-01-2025
        setSelectPlan(e.target.value)

        if (e.target.value.length > 0) {
            setkycRefCode("")
            setKycAadhar("")
            setKycClient("")
            setKycName("")
            setKycEmail("")
            setKycMobile("")
            setKycAadhar("")
        }
    })

    const handleKycFDate = useCallback((newValue) => {
        setKycFDate(dayjs(newValue).format('YYYY-MM-DD'))
        setKycName("") //dev-trupti on 17-12-2024
        setKycEmail("")
        setKycMobile("")
        setKycAadhar("")
        setkycRefCode("")
        setKycClient("") //dev-trupti on 26-12-2024
    }, [])

    const handleKycTDate = useCallback((newValue) => {
        setKycTDate(dayjs(newValue).format('YYYY-MM-DD'))
        setKycName("") //dev-trupti on 17-12-2024
        setKycEmail("")
        setKycMobile("")
        setKycAadhar("")
        setkycRefCode("")
        setKycClient("") //dev-trupti on 26-12-2024   
    }, [])

    const handleKycName = useCallback((e) => {
        setKycName(e.target.value)
        console.log("e",kycEmail)
        if(e.target.value.length > 0){
            setKycFDate(null)
            setKycTDate(null)
            setkycRefCode("") //dev-trupti on 17-12-2024
            setKycAadhar("")
            setKycClient("") //dev-trupti on 26-12-2024
            setSelectPlan("") // kartik - 10-01-2025
        } 
    }, [])

    const handleKycEmail = useCallback((e) => {
        setKycEmail(e.target.value)
         console.log("emaaill",kycEmail,kycName)
        if(e.target.value.length > 0){
            console.log("emaaill11", kycEmail, kycName)
            setKycFDate(null)
            setKycTDate(null)
            setkycRefCode("") //dev-trupti on 17-12-2024
            setKycAadhar("")
            setKycClient("") //dev-trupti on 26-12-2024
            setSelectPlan("") // kartik - 10-01-2025
        }
    }, [])

    const handleKycMobile = useCallback((e) => {
        setKycMobile(e.target.value)

        if(e.target.value.length > 0){
            setKycFDate(null)
            setKycTDate(null)
            setkycRefCode("") //dev-trupti on 17-12-2024
            setKycAadhar("")
            setKycClient("") //dev-trupti on 26-12-2024
            setSelectPlan("") // kartik - 10-01-2025
        }
    }, [])

    const handleKycAadhar = useCallback((e)=>{
        setKycAadhar(e.target.value)

        if(e.target.value.length > 0){
            setKycFDate(null)
            setKycTDate(null)
            setKycName("") //dev-trupti on 17-12-2024
            setKycEmail("")
            setKycMobile("")
            setkycRefCode("")
            setKycClient("") //dev-trupti on 26-12-2024
            setSelectPlan("") // kartik - 10-01-2025
        }
    }, [])
// Added refcode by dev-trupti 22-10-2024
    const handlekycRefCode = useCallback((e)=>{
        setkycRefCode(e.target.value)

        if(e.target.value.length > 0){
            setKycFDate(null)
            setKycTDate(null)
            setKycName("") //dev-trupti on 17-12-2024
            setKycEmail("")
            setKycMobile("")
            setKycAadhar("")
            setKycClient("") //dev-trupti on 26-12-2024
            setSelectPlan("") // kartik - 10-01-2025
        }
    }, [])
//dev-trupti on 26-12-2024
    const handleKycClient = useCallback((e)=>{
        setKycClient(e.target.value)
        console.log(kycClient)

        if(e.target.value.length > 0){
            setKycFDate(null)
            setKycTDate(null)
            setKycName("") //dev-trupti on 17-12-2024
            setKycEmail("")
            setKycMobile("")
            setKycAadhar("")
            setkycRefCode("")
            setSelectPlan("") // kartik - 10-01-2025
        }
    }) 

    const handleEditModal = useCallback(() => {
        setEditModal(false)
    }, [])

    const handlePrefix = useCallback((e) => {
        setPrefix(e.target.value)
    }, [])

    const handleAccountno = useCallback((e) => {
        setAccountNo(e.target.value)
    }, [])

    const handleFatherName = useCallback((e) => {
        setFatherName(e.target.value)
    }, [])

    const handleNewFilter = useCallback((e) => {
        setFilterModel(e)
    }, [])

    const handlecheckboxChange = (e, str, checkBoxStatus) => { 
            // Latest data shows at first -25/09/24 - dev Srini
        // setcheckboxToggle(!checkboxToggle)
        setcheckboxToggle(str)
        let kycFilter = []
        if (str === "completed") {
            console.log("before",e.target.checked,str,completeKyc)
            kycFilter = completeKyc.filter(item => item.kyc_status == 'completed')
            console.log("after", e.target.checked, str, kycFilter)
            setSelectedStatus("completed")
            let sortResult = sortGetData(kycFilter)
            setIncompleteKyc(sortResult)
            console.log("Sorted final data", sortResult) //dev-trupti on 17-12-2024
        } 
        // else if(str === "incompleted" && e.target.checked === false){
        //     kycFilter = completeKyc.filter(item => item.stage == 'completed')
        //     setIncompleteKyc(kycFilter)
        // }
        else if (str === "in_progress"){
            kycFilter = completeKyc.filter(item => item.kyc_status == "in_progress" );
            setSelectedStatus("in_progress")
            let sortResult = sortGetData(kycFilter)
            setIncompleteKyc(sortResult)
            console.log("Sorted final data", sortResult) //dev-trupti on 17-12-2024
        }
        else if (str === "document_verification"){ //dev-trupti on 26-11-2024
            // if(checkBoxStatus==="INACTIVE"){
            kycFilter = completeKyc.filter(item => item.kyc_status == 'document_verification')
                let sortResult = sortGetData(kycFilter)
                setSelectedStatus("document_verification")
                setIncompleteKyc(sortResult)
                console.log("Sorted final data", sortResult) //dev-trupti on 17-12-2024
            // }else{
            //     kycFilter = completeKyc.filter(item => item.kyc_status !== 'completed')
            //     let sortResult = sortGetData(kycFilter)
            //     setIncompleteKyc(sortResult)
            //     console.log("Sorted final data", sortResult) //dev-trupti on 17-12-2024
            // }
        }else{
            kycFilter = completeKyc.filter(item => item.kyc_status == 'completed_bo_pending')
            let sortResult = sortGetData(kycFilter)
            setSelectedStatus("completed_bo_pending")
            setIncompleteKyc(sortResult)
            console.log("Sorted final data", sortResult)
        }     
    }

    const action = (
        <IconButton color="#000000" size="small" onClick={()=>{
            setSnack(false)
            setMsg("")
        }}>
          <CloseIcon/>
        </IconButton>
      );
    //  download csv fiel - srini - 21/11/24
    const handleDownloadCsv = () => {
        const header = ["ACOP Start Date", "Account", "Last Activity", "Name", "Email", "Phone", "Stage"]

        const data = inCompleteKyc.map(item => {
            return{
                [header[0]]: `${item.createdAt?.split("T")[0]} - ${item.createdAt?.split("T")[1]?.split(".")[0]}`,
                [header[1]]: `${item.client_id || ''}`,
                [header[2]]: `${item.updatedAt?.split("T")[0]} - ${item.updatedAt?.split("T")[1]?.split(".")[0]}`,
                [header[3]]: item.name ? item.name : '-',
                [header[4]]: `${item.email}`,
                [header[5]]: `${item.mobile}`,
                [header[6]]: `${item.kyc_status}`,
                // [header[9]]: item.backoffice == 1 ? 'Yes' : 'No',
                // [header[10]]: item.refcode && item.refcode !== "undefined" ? item.refcode : '-',
                // [header[11]]: item.dramount ? item.dramount : "-" //dev-karthik on 21-01-2025
            }
        })

        const fileName = 'KYC Report'
        const exportType = exportFromJSON.types.csv
        exportFromJSON({data, fileName, exportType})
    }

    const handleTabChange = (event, newValue) => {
        setTabId(newValue);
    };

    return (
        //changed to class dev-trupti on 23-10-2024
        <div className={classes.scrollTable}> 
        <Snackbar
                anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "right"
                }}
                open={snack}
                autoHideDuration={2000}
                onClose={()=>{
                    setSnack(false)
                    setMsg("")
                }}
            >
                <SnackbarContent
                sx={{backgroundColor:'#ffffff !important',
                    color:'black !important',
                    // borderLeft:"7px solid #8db600 !important",
                    borderRadius:'3px !important',
                    fontFamily:'cardiuma-regular !important',
                    fontSize:'12px !important'
                }}
                action={action}
                    message={msg}
                />
            </Snackbar>
            <Typography
                className={classes.dashboardText2}
                style={{ color: '#FFFFFF', marginTop: '7%' }}
            >KYC Dashboard</Typography>

            <Grid container alignItems="flex-end">
                <Grid item xs={10}>
                    <Tabs
                        value={tabId}
                        onChange={handleTabChange}
                        variant="standard"
                        classes={{ indicator: classes.indicator }}
                        indicatorColor="primary"
                        style={{ margin: "2% 0 0 0" }}
                    >
                        <Tab
                            value={1}
                            className={classes.pending_heading2}
                            label={`Incomplete Users`} // srini - 18-06-25
                            style={{
                                borderBottom:
                                    tabId !== 1 ? "2px solid #131E2E" : "2px solid #F3D45E",

                            }}
                        />
                        <Tab
                            value={2}
                            className={classes.pending_heading2}
                            label={`Leads`} //srini - 18-06-25
                            style={{
                                borderBottom:
                                    tabId !== 2 ? "2px solid #131E2E" : "2px solid #F3D45E",
                            }}
                        />
                        </Tabs>
                    </Grid>

            </Grid>


            {
                tabId === 1 && (
                    <>
                        <DateFields
                            kycFdate={kycFdate}
                            kycTdate={kycTdate}
                            handleKycFDate={handleKycFDate}
                            handleKycTDate={handleKycTDate}
                            kycClient={kycClient}//dev-trupti on 26-12-2024
                            handleKycClient={handleKycClient}
                            handlePlans={handlePlans} // kartik - 10-01-2025
                            selectPlan={selectPlan} // kartik - 10-01-2025          
                        // checkboxToggle={checkboxToggle}
                        // handlecheckboxChange={handlecheckboxChange}
                        // status={status} //dev-trupti on 26-11-2024
                        // setStatus={setStatus}
                        // hide={hide}
                        // setHide={setHide}
                        />

            <EmailNameMobileFields
                kycName={kycName}
                kycEmail={kycEmail}
                kycMobile={kycMobile}
                kycAadhar={kycAadhar}
                kycrefCode={kycrefCode} //dev-trupti 22-10-2024
                handleKycName={handleKycName}
                handleKycEmail={handleKycEmail}
                handleKycMobile={handleKycMobile}
                handleKycAadhar={handleKycAadhar}
                handlekycRefCode={handlekycRefCode} //dev-trupti 22-10-2024
                handleInCompleteKycSubmit={handleInCompleteKycSubmit}
                handleReset={handleReset} //dev-trupti on 24-10-2024
                handleDownloadCsv={handleDownloadCsv} // srini - 21/11/24
            />

                        <FilterButtons 
                            allKycData={allKycData}
                            handlecheckboxChange={handlecheckboxChange}
                            selectedStatus={selectedStatus}
                        />

                        {/* <FilterFields //dev-trupti on 26-12-2024
                            checkboxToggle={checkboxToggle}
                            handlecheckboxChange={handlecheckboxChange}
                            status={status} //dev-trupti on 26-11-2024
                            setStatus={setStatus}
                            hide={hide}
                            setHide={setHide}
                            count={count} // kartik - 16-01-2025
                        /> */}


            <TableDisplay
                inCompleteKyc={inCompleteKyc}
                handleEditDetails={handleEditDetails}
                filterModel={filterModel}
                handleNewFilter={handleNewFilter}
            />

                        <EditActionModal
                            accountno={accountno}
                            editModal={editModal}
                            fatherName={fatherName}
                            prefix={prefix}
                            selectUser={selectUser}
                            handleAccountno={handleAccountno}
                            handleEditModal={handleEditModal}
                            handlePrefix={handlePrefix}
                            aadhar={aadhar}
                            phone={phone}
                            email={email}
                            accountnumber={accountnumber}
                            regData={regData}
                            load={load}
                            setLoad={setLoad}
                            bankAccount={bankAccount}
                            setBankAccount={setBankAccount}
                            image={image}
                            setImage={setImage}
                            CompletedVerification={CompletedVerification}
                            disRepush={disRepush}
                            setDisRepush={setDisRepush}
                            setSnack={setSnack}
                            setMsg={setMsg}
                            subData={subData} //dev-trupti on 31-10-2024
                            nri={nri}
                            docstatus={docstatus}
                            setDocstatus={setDocstatus}
                            docobj={docobj}
                            // added by dev-kartik on 02-04-25
                       



               
                perData={perData}
                kycDetails={kycDetails}
                setNum={setNum}
                picDetails={picDetails}
                id={id}
                setPicDetails={setPicDetails}
                docVerification={docVerification}
                setDocVerification={setDocVerification}
                setPerData={setPerData}
                setRegData={setRegData}
                bankData={bankData}
                personalDetails={personalDetails}
                segmentDetails= {segmentDetails}
                nomineeDetails={nomineeDetails}

                            details={details}
                        />
                    </>
                )
            }

            {
               tabId == 2 && (
                 <Lead classes={classes}/>
               )
            }

           

        </div>
    )
}

export default withStyles(styles)(InCompleteKYC)